import * as tslib_1 from "tslib";
import React from 'react';
import { withTranslation } from 'react-i18next';
import Input from '../../Input';
import BaseConfirmationPopup from '../BaseConfirmationPopup';
var PromptPopup = /** @class */ (function (_super) {
    tslib_1.__extends(PromptPopup, _super);
    function PromptPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            inputValue: _this.props.initialInputValue || '',
            hasChanged: false,
        };
        _this.onInputKeyDown = function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                _this.onDone();
            }
        };
        _this.updateInputValue = function (value) {
            _this.setState({ inputValue: value, hasChanged: true });
        };
        _this.onDone = function () {
            var onDone = _this.props.onDone;
            var inputValue = _this.state.inputValue;
            onDone && onDone(inputValue);
        };
        return _this;
    }
    PromptPopup.prototype.render = function () {
        var _a = this.props, t = _a.t, isOpen = _a.isOpen, title = _a.title, inputLabel = _a.inputLabel, onCancel = _a.onCancel, onInputValidate = _a.onInputValidate, _b = _a.doneButtonLabel, doneButtonLabel = _b === void 0 ? t('popup.done') : _b, inputWrapperClassName = _a.inputWrapperClassName, children = _a.children, maxLength = _a.maxLength;
        var _c = this.state, inputValue = _c.inputValue, hasChanged = _c.hasChanged;
        var errorHint = hasChanged && onInputValidate ? onInputValidate(inputValue) : undefined;
        return (React.createElement(BaseConfirmationPopup, { isOpen: isOpen, title: title, confirmDisabled: !!errorHint, confirmButtonLabel: doneButtonLabel, onCancel: onCancel, onDone: this.onDone },
            children,
            React.createElement("div", { className: inputWrapperClassName },
                React.createElement(Input, { autoFocus: true, value: inputValue, label: inputLabel, errorMessage: errorHint, onChange: this.updateInputValue, onKeyDown: !errorHint ? this.onInputKeyDown : undefined, maxLength: maxLength }))));
    };
    return PromptPopup;
}(React.Component));
export { PromptPopup };
export default withTranslation()(PromptPopup);
//# sourceMappingURL=PromptPopup.js.map